export const meta = {
  slug: { de: "rueckenschmerzen-wann-zum-arzt", en: "back-pain-when-to-see-a-doctor" },
  title: "Rückenschmerzen: wann ein Arztbesuch wirklich notwendig ist",
  excerpt:
    "Die meisten Rückenschmerzen sind harmlos und bessern sich von selbst. Es gibt aber klare Anzeichen, bei denen ein zeitnaher Arztbesuch wichtig ist.",
  category: "patienten",
  publishedAt: "2026-04-18",
  metaTitle: "Rückenschmerzen – wann zum Arzt | OnePractix",
  metaDescription:
    "Welche Rückenschmerzen harmlos sind und welche Anzeichen einen zeitnahen Arztbesuch erfordern – ruhige, strukturierte Einordnung für Patienten.",
  related: ["knieschmerzen-was-tun", "orthopaede-termin-schnell"],
  en: {
    title: "Back pain: when a doctor's visit is really necessary",
    metaTitle: "Back pain – when to see a doctor | OnePractix",
    metaDescription:
      "Which back pain is harmless and which signs require a timely visit to the doctor — calm, structured guidance for patients.",
    excerpt:
      "Most back pain is harmless and improves on its own. But there are clear warning signs where a timely visit to the doctor matters.",
  },
};

export default meta;
